export type TalentRankRecommendation = '10x' | '9x' | 'average' | 'mismatch'

const TALENT_RANK_SUGGESTION_MATCHERS: Record<TalentRankRecommendation, string[]> = {
  '10x': ['10x', 'top talent', 'top (10x)'],
  '9x': ['9x', 'growth talent', 'growth (9x)', 'expert talent'],
  average: ['core', 'core talent', 'average', 'average talent'],
  mismatch: ['mismatch', 'mismatch ⚠️', 'underperforming'],
}

export const determineTalentRankRecommendation = (scores: number[]): TalentRankRecommendation => {
  if (scores.length === 0) {
    return 'average'
  }

  const sum = scores.reduce((total, score) => total + score, 0)
  const average = sum / scores.length

  if (average >= 90) {
    return '10x'
  }

  if (average >= 83) {
    return '9x'
  }

  if (average < 60) {
    return 'mismatch'
  }

  return 'average'
}

export const findTalentRankOption = (
  options: string[],
  recommendation: TalentRankRecommendation
): string | undefined => {
  const normalizedOptions = options.map(option => option.toLowerCase())
  const matchers = TALENT_RANK_SUGGESTION_MATCHERS[recommendation]
  const matcherIndex = normalizedOptions.findIndex(option => matchers.some(matcher => option.includes(matcher)))

  if (matcherIndex !== -1) {
    return options[matcherIndex]
  }

  const fallbackIndex = normalizedOptions.findIndex(option => option === recommendation)
  return fallbackIndex !== -1 ? options[fallbackIndex] : undefined
}
